import { Link } from "react-router-dom";
import { base64Encode } from "../../Layout/Common/common";
import { useAuth } from "../../Context/AuthContext";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { Fragment } from "react";
export const CatalogueHeader = ({ activeTab, setActiveTab }) => {
  const { userId, isAuthenticated } = useAuth();
  return (
    <section className="wesCatalogue-section">
      <div className="container-fluid container-lg">
        <div className="row">
          <div className="col-lg-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/home">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Catalogue
                </li>
              </ol>
            </nav>
          </div>
        </div>

        {/* SwitchTransition ensures only one child is mounted at a time */}
        <SwitchTransition mode="out-in">
          <CSSTransition key={activeTab} timeout={300} classNames="fade">
            <div>
              {activeTab === "catalogue" ? (
                <WesCatalogueHeader activeTab={activeTab} setActiveTab={setActiveTab} />
              ) : (
                <FlyersHeader />
              )}
            </div>
          </CSSTransition>
        </SwitchTransition>
      </div>
    </section>
  );
};

const WesCatalogueHeader = ({ activeTab, setActiveTab }) => {
  const { userId } = useAuth();
  const pdfSource = process.env.REACT_APP_wesCataloguePdfPath;

  return (
    <div className="row align-items-center mt-3 desk-fixed-height-200">
      <div className="col-md-7">
        <div className="wesCatalogue-content pe-4">
          <h1 className="mb-4">WES Catalogue Downloads</h1>
          <p className="mb-2">
            Browse our latest product catalogues in either online eBook or downloadable PDF formats.
          </p>
          <p className="mb-2">For the best viewing experience, we recommend using the eBook version</p>
          <div className="wesCatalogue-btns">
            <div className="button-effect">
              <Link
                to={"/ViewEbook/L21lZGlhcHViL2Vib29rL3dlc2NhdDIwMjMv"}
                target="_blank"
                className="btn btn-products btn-addcart"
              >
                Catalogue eBook
              </Link>
            </div>
            {userId && (
              <Fragment>
                <div className="wesCatlogue border-link">
                  {pdfSource && (
                    <Link to={pdfSource} target="_blank">
                      Catalogue PDF
                    </Link>
                  )}
                </div>
                <div className="wesCatlogue border-link border-linkMob">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveTab("flyers");
                    }}
                  >
                    WES New Latest Flyers
                  </Link>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
      <div className="col-md-5">
        <div className="wesCatalogue-bannerImage">
          <ImageWithDefault
            src="https://cdn.wes.com.au/wesreact/newui/img/catalogue/catalogue-banner.png"
            alt="catalogue banner"
            classList="img-fluid w-100 rounded-4"
          />
        </div>
      </div>
    </div>
  );
};

const FlyersHeader = () => {
  return (
    <div className="row align-items-center mt-3 desk-fixed-height-200">
      <div className="col-md-7">
        <div className="wesCatalogue-content pe-4">
          <h1 className="mb-4">WES NEWS Updates</h1>
          <p className="mb-2">
            Stay up to date with our latest product releases, updates, and supplier news—all in one place.
          </p>
          <p className="mb-2">For the best viewing experience, we recommend using the eBook version</p>
        </div>
      </div>
      <div className="col-md-5">
        <div className="wesCatalogue-bannerImage">
          <ImageWithDefault
            src="https://cdn.wes.com.au/wesreact/newui/img/catalogue/flyerbanner.png"
            alt="Flyer banner"
            classList="img-fluid w-100 rounded-4"
          />
        </div>
      </div>
    </div>
  );
};
